<template>
  <VaccinationPage
    title="Kidney Diseases"
    :buttons="buttons"
    baseRoute="/KidneyDiseasesSecond"
    :bottomImage="require('@/assets/page12/Asset 96.png')"
    :footerBanner="require('@/assets/page4/lowererPanner.png')"
    prevRoute="/vaccination"
    nextRoute="/KidneyDiseasesSecond"
  />
</template>

<script setup>
import VaccinationPage from "@/components/VaccinationPage.vue";

const buttons = [
  { imgPath: require("@/assets/page12/Asset 81.png"), name: "Influenza" },
  { imgPath: require("@/assets/page12/Asset 83.png"), name: "Pneumococcal" },
  { imgPath: require("@/assets/page12/Asset 84.png"), name: "RSV" },
  { imgPath: require("@/assets/page12/Asset 86.png"), name: "MMR" },
  { imgPath: require("@/assets/page12/Asset 87.png"), name: "Varicella" },
  { imgPath: require("@/assets/page12/Asset 88.png"), name: "Zoster" },
  { imgPath: require("@/assets/page12/Asset 89.png"), name: "COVID-19" },
  { imgPath: require("@/assets/page12/Asset 90.png"), name: "Tetanus" },
  { imgPath: require("@/assets/page12/Asset 91.png"), name: "Humanpapilloma" },
  { imgPath: require("@/assets/page12/Asset 92.png"), name: "HepatitisA" },
  { imgPath: require("@/assets/page12/Asset 93.png"), name: "HepatitisB" },
  { imgPath: require("@/assets/page12/Asset 94.png"), name: "MeningococcalMenB" },
];
</script>